import { TableData } from "@/components/Table/type"
import { useTable } from "@/hooks/useTable"
import { ResearchedProduct } from "@/types/MarketResearch"
import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from "react"
import Table from '@/components/Table'
import DefaultColumn from '@/components/Table/components/DefaultColumn' 
import TableRowActions from "@/components/Table/components/TableRowActions"
import { currencyFormat, numberFormat } from "@/utils/stringFormatter"
import { getTimeDate } from "@/utils/date"
import { Eye } from "lucide-react"

export type ReseachedProductTable = TableData<ResearchedProduct >

const columnHelper = createColumnHelper<ResearchedProduct >()

interface props {
    dataResearchedProduct :ResearchedProduct [], 
    handleViewImage: (key: string) => void
}
const TableProductMarketResearch = ({ dataResearchedProduct, handleViewImage }: props) => {    
    const { 
        tableState, 
        setTable,  
    } = useTable<ResearchedProduct >('')
  
    const memoData = useMemo(() => dataResearchedProduct ?? [], [dataResearchedProduct])
    const memoColumns = useMemo(
        () => [  
            columnHelper.accessor('DS_REVENDA', {
                id: 'DS_REVENDA',
                header: 'Revenda',
                size: 120,
            }),  
            columnHelper.accessor('NM_USUARIO', {
                id: 'NM_USUARIO',
                header: 'Representante',
                size: 160,
            }),  
            columnHelper.accessor('DS_NOME_FANTASIA', {
                id: 'DS_NOME_FANTASIA',
                header: 'PDV',
                size: 240,
            }),  
            columnHelper.accessor('DS_PRODUTO', {
                id: 'DS_PRODUTO',
                header: 'Produto',
                size: 280,
            }),    
            columnHelper.accessor(({ VL_PRECO_COMPRA }) =>
                VL_PRECO_COMPRA
                    ? currencyFormat(Number(VL_PRECO_COMPRA))
                    : currencyFormat(0), {
                cell: props => (
                    <p className="text-right w-full">{`${props.getValue() || ''}`}</p>
                ),
                sortingFn: (rowA, rowB, _columnId) => {
                    const statusA = rowA.original[_columnId]
                    const statusB = rowB.original[_columnId]
                    return Number(statusA) < Number(statusB) ? 1 : -1
                },
                id: 'VL_PRECO_COMPRA',
                header: 'Vl. Compra',
                size: 120,
            }),  
             columnHelper.accessor(({ QTD_VOLUME_COMPRA }) =>
                QTD_VOLUME_COMPRA
                    ? numberFormat(Number(QTD_VOLUME_COMPRA))
                    : numberFormat(0), {
                cell: props => (
                    <p className="text-right w-full">{`${props.getValue() || ''}`}</p>
                ),
                sortingFn: (rowA, rowB, _columnId) => {
                    const statusA = rowA.original[_columnId]
                    const statusB = rowB.original[_columnId]
                    return Number(statusA) < Number(statusB) ? 1 : -1
                },
                id: 'QTD_VOLUME_COMPRA',
                header: 'Qtd. Compra',
                size: 120,
            }),   
            columnHelper.accessor(({ VL_PRECO_VENDA }) =>
                VL_PRECO_VENDA
                    ? currencyFormat(Number(VL_PRECO_VENDA))
                    : currencyFormat(0), {
                cell: props => (
                    <p className="text-right w-full">{`${props.getValue() || ''}`}</p>
                ),
                sortingFn: (rowA, rowB, _columnId) => {
                    const statusA = rowA.original[_columnId]
                    const statusB = rowB.original[_columnId]
                    return Number(statusA) < Number(statusB) ? 1 : -1
                },
                id: 'VL_PRECO_VENDA',
                header: 'Vl. Venda',
                size: 120,
            }),  
            columnHelper.accessor('DD_STATUS', {
                id: 'DD_STATUS',
                header: 'Status Lançamento',
                size: 155,
            }),   
            columnHelper.accessor(({ DT_PUBLICACAO }) =>
                    DT_PUBLICACAO
                ? getTimeDate(new Date(DT_PUBLICACAO))
                : '', {
                id: 'DT_PUBLICACAO',
                header: 'Dt. Publicação',
                size: 130,
            }), 
            columnHelper.accessor(({ CREATED_AT }) =>
                    CREATED_AT
                ? getTimeDate(new Date(CREATED_AT))
                : '', {
                id: 'CREATED_AT',
                header: 'Dt. Criação',
                size: 130,
            }),     
            columnHelper.accessor(({ DD_PRODUTO_EXTRA }) =>
                    DD_PRODUTO_EXTRA == 1
                ? 'Sim'
                : 'Não', {
                id: 'DD_PRODUTO_EXTRA',
                header: 'Extra pesquisa?',
                size: 140,
            }),
            columnHelper.display({
                id: 'Ações',
                cell: ({ row }) => {  
                    if(!row.original.DS_CHAVE_ARQUIVO){
                        return ''
                    }
                    return (
                        (
                            <TableRowActions  
                                actions={[
                                    {
                                        action: () => { 
                                            handleViewImage(row.original.DS_CHAVE_ARQUIVO) 
                                        },
                                        label: `Visualizar Imagem`,
                                        icon: <Eye size={14} />
                                    }
                                ]} 
                            />
                        )
                    )
                }, 
                size: 60,
                enableColumnFilter: false,
                enableSorting: false, 
            }), 
        ],
        []
    )

    if(memoData.length === 0) return null

    return ( 
            <div className="flex-1 overflow-hidden">
                <Table<ReseachedProductTable>
                    data={memoData}
                    columns={memoColumns}
                    getRowId={(row) => row.SK_PRODUTOS_PESQUISADOS.toString()} 
                    getTableInstance={(table) => setTable(table)}   
                    tableState={tableState} 
                    defaultColumn={{
                        cell: ({ getValue }) => (
                            <DefaultColumn>{getValue() as string}</DefaultColumn>
                        ),
                    }}
                /> 
            </div> 
    )
}

export default TableProductMarketResearch
